const calculateAgeInYears = (dob) => {
  const birthDate = new Date(dob);
  const currentDate = new Date();

  let years = currentDate.getFullYear() - birthDate.getFullYear();
  let months = currentDate.getMonth() - birthDate.getMonth();
  let days = currentDate.getDate() - birthDate.getDate();

  if (days < 0) {
    months -= 1;
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Return age as "2.10" for 2 years and 10 months
  const formatted = `${years}.${months}`;
  return formatted;
};

export { calculateAgeInYears };
